import { useQuery } from '@tanstack/react-query';

import fetchProjectPart from '../api/fetchProjectPart';

const useGetProjectPartByDocId = ({ projectDocId, pPartDocId }) => useQuery({
  queryKey: ['getProjectPartByDocId', projectDocId, pPartDocId],
  queryFn: () => fetchProjectPart({ projectDocId, pPartDocId }),
  enabled: !!projectDocId && !!pPartDocId,
  staleTime: 10 * 60 * 1000, // Cache data for 10 minutes
});

export default useGetProjectPartByDocId;
